<mat-form-field #formFieldContainer class="email-class">
  <mat-label
    #labelContainer (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">{{componentDefinition?.label}}</mat-label>

  <div class="labelToolTipContainer"
       #tooltip="matTooltip"
       matTooltip="{{componentDefinition.label}}"
       [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>
    <input matInput type="email" placeholder="{{ componentDefinition?.label }}"
           [id]="elementName + document.documentId" [name]="componentDefinition?.name"
           [readonly]="disabled"
           [formControl]="formControl"
           [errorStateMatcher]="matcher">

    <a *ngIf="fieldValue"
       mat-icon-button matSuffix
       class="mailto-link"
       [href]="href"
       [matTooltip]="href">
      <mat-icon color="primary" >mail</mat-icon>
    </a>
</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
